import React from 'react';
import ApplyInput from '../components/ApplyInput';
import ApplyStep from '../components/ApplyStep';
import Footer from '../components/Footer';
import './ApplyPage.css';
import ReactLoading from "react-loading";
import API from '../API';
import ApplyDocumentInput from '../components/ApplyDocumentInput';

function iframe() {
    return {
        __html: '<iframe src="../teslimatsirketi.html" style="border: none;" width="100%" height="450"></iframe>'
    }
}

export default class ApplyPage extends React.Component {

    constructor(props) {
        super(props);
        
        
        this.state = {step: 0, formData: {firstName: "", lastName:"", email:"", tel:"", tc:"", vkn:"",type:-1,files:{},vehicles: [{}]}}
        var id = window.location.href.split("apply/")[1];
        if(id) {
            this.state.step = -1;
            window.applicationId = id;
            API.fetch('getapplication', {id}).then((application) => {
                if(application.error) {
                    this.setState({step: -2});
                } else {
                    if(application.status == 1) {
                        this.setState({step: 5});
                        return;
                    }

                    if(!application.vehicles) application.vehicles = [{}];
                    if(!application.files) application.files = {};

                    
                    this.setState({formData: application, step: 1});
                }
            });
        }
    }

    
    render() {

        var step1Disabled = false;
        if(this.state.step == 1) {
            for(var i = 0; i < 4; i++) {
                if(!this.state.formData.files || !this.state.formData.files[i]) step1Disabled = true;
            }
            
            
        }

        var step2Disabled = false;
        if(this.state.step == 2) {
            for(var i = 0; i < this.state.formData.vehicles.length; i++) {
                var vehicle = this.state.formData.vehicles[i];
                if(!vehicle.ruhsat || !vehicle.license) step2Disabled = true;
                //if(!vehicle.side || !vehicle.front || !vehicle.license) step2Disabled = true;
            }
        }
        
        return <div style={{width:"100%", height:"100%", flexDirection:"column", alignItems:"center",paddingBottom:50}}>
            <div style={{backgroundColor:"#3c9cd7", height:184}}></div>
            
            
            <div style={{justifyContent:"center", display:"flex", marginTop:50}}>
                {this.state.step == -1 && <div>

                    <ReactLoading type='spin' color='#3c9cd7' />
                    </div>}
                {this.state.step == 0 && <ApplyStep disabled={this.state.formData.type == -1} onNext={() => {
                    this.setState({step: -1});
                    
                    API.fetch("createapplication", this.state.formData).then((dat) => {
                        
                        if(dat.error != undefined) {
                            this.setState({step: -2,error: dat.error});
                        } else {
                            window.location.href = "/apply/" + dat.id;
                        }
                    });
                }}>

                <ApplyInput val={this.state.formData.firstName} onChangeText={(t) => {this.state.formData.firstName = t; this.forceUpdate()}} label={'AD'} />
                <ApplyInput val={this.state.formData.lastName} onChangeText={(t) => {this.state.formData.lastName = t; this.forceUpdate()}} label={'SOYAD'} />
                <ApplyInput val={this.state.formData.email} onChangeText={(t) => {this.state.formData.email = t; this.forceUpdate()}} type='email' label={'EMAIL'} />
                <ApplyInput val={this.state.formData.tel} onChangeText={(t) => {this.state.formData.tel = t; this.forceUpdate()}} type='tel' label={'TELEFON NUMARASI'} />
                {/* <ApplyInput val={this.state.formData.tc} onChangeText={(t) => {this.state.formData.tc = t; this.forceUpdate()}} label={'T.C. KIMLIK NO'} /> */}
                {/* <ApplyInput val={this.state.formData.vkn} onChangeText={(t) => {this.state.formData.vkn = t; this.forceUpdate()}} label={'V.K.N.'} /> */}
                

                <div className={this.props.full?'applyInput full':'applyInput'}>
            <p style={{fontSize:16, fontWeight:600, letterSpacing:".4px", color: "hsl(220, 7%, 17%)", marginBottom:15,lineHeight:"8px"}}>ARAÇ TIPI</p>
            <select style={{paddingRight:20}} value={this.state.formData.type} onChange={(e) => {
                            this.state.formData.type = e.target.value;
                            this.forceUpdate();
                        }} required>
                            <option disabled selected value={-1}>Seçiniz</option>
                            <option value={0}>Motorsiklet</option>
                            <option value={2}>Doblo</option>
                            <option value={3}>Minivan</option>
                            <option value={4}>Panelvan</option>
                            <option value={5}>Kamyonet</option>
                        </select>
        </div>
                <p style={{marginTop:20,fontSize:16, color:"#575858"}}>İlerlediğiniz zaman belirttiğiniz e-posta adresine başvurunuza kaldığınız yerden devam edebilmeniz için bir bağlantı gönderilmiş olucak. Yeni bir başvuru oluşturmanıza gerek olmadan bilgilerinizi güncellemek için bağlantıyı kullanabilirsiniz</p>
                <p style={{marginTop:5,fontSize:16, color:"#575858"}}>İletilmemiş e-postalar için Gereksiz ve Spam klasörlerinizi kontrol ettiğinizden emin olun</p>
                
                <p style={{marginTop:20,fontSize:16, color:"#575858"}}>Bize telefon numaranızı vererek ve "Gönder"e tıklayarak, başvurunuzla ilgili olarak sizi aramamızı veya size kısa mesaj göndermemizi kabul etmiş olursunuz. Mesaj ve veri ücretleri geçerli olabilir.</p>
                
                </ApplyStep>}

                {this.state.step == 1 && <ApplyStep disabled={step1Disabled} onNext={() => this.onNext()}>

                <ApplyDocumentInput first label="Sürücü Belgesi (Ön)" onFileChange={(file) => {
                    this.state.formData.files[0] = file;
                    this.forceUpdate();
                }} file={this.state.formData.files[0]} type={0} />


                <ApplyDocumentInput label="Sürücü Belgesi (Arka)" onFileChange={(file) => {
                    this.state.formData.files[1] = file;
                    this.forceUpdate();
                }} file={this.state.formData.files[1]} type={1} />


                <ApplyDocumentInput label="İkametgah Belgesi" onFileChange={(file) => {
                    this.state.formData.files[2] = file;
                    this.forceUpdate();
                }} file={this.state.formData.files[2]} type={2} />


                <ApplyDocumentInput label="Adli Sicil Kaydı" onFileChange={(file) => {
                    this.state.formData.files[3] = file;
                    this.forceUpdate();
                }} file={this.state.formData.files[3]} type={3} />

                <ApplyDocumentInput label="Fotoğrafınız (Ön Çekim)" onFileChange={(file) => {
                    this.state.formData.files[4] = file;
                    this.forceUpdate();
                }} file={this.state.formData.files[4]} type={4} />
 
                <p style={{marginTop:20, marginBottom:20,fontSize:16, color:"#575858"}}>Bize telefon numaranızı vererek ve "Gönder"e tıklayarak, başvurunuzla ilgili olarak sizi aramamızı veya size kısa mesaj göndermemizi kabul etmiş olursunuz. Mesaj ve veri ücretleri geçerli olabilir.</p>
                
                </ApplyStep>}


                {this.state.step == 2 && <ApplyStep disabled={step2Disabled} onPrev={() => this.onPrev()} onNext={async () => {
                    this.setState({step: -1});
                    await API.fetch("bunchvehicleupdate", {id: window.applicationId, vehicles: this.state.formData.vehicles}).then((e) => {
                        this.setState({step:3});
                    })
                    
                }}>


                {this.state.formData.vehicles.map((vehicle,indx) => <div key={indx} className='vehicleInput' style={{width:"100%", marginTop:(this.props.first)?0:50}}>

                    <p style={{color: "hsl(197, 8%, 17%)", fontWeight:700, fontSize:25, marginBottom:10}}>Araç {indx+1}</p>

                    <ApplyInput onChangeText={(text) => {
                        vehicle.license = text;
                        this.forceUpdate();
                    }} placeholder={"34 ABC 123"} val={vehicle.license?vehicle.license:""} label="Plaka" />

                    <div className={this.props.full?'applyInput full':'applyInput'}>
                        <p style={{fontSize:16, fontWeight:600, letterSpacing:".4px", color: "hsl(220, 7%, 17%)", marginBottom:15,lineHeight:"8px"}}>Araç Tipi</p>
                        <select value={vehicle.type?vehicle.type:0} onChange={(e) => {
                            vehicle.type= e.target.value;
                            this.forceUpdate();
                        }} type={(this.props.type)?this.props.type:'text'} required>
                            <option value={0}>Motorsiklet</option>
                            <option value={2}>Doblo</option>
                            <option value={3}>Minivan</option>
                            <option value={4}>Panelvan</option>
                            <option value={5}>Kamyonet</option>
                        </select>
                    </div>

                    {/* <ApplyDocumentInput onFileChange={(file) => {
                        vehicle.front = file;
                        this.forceUpdate();
                    }} file={vehicle.front} getVehicleId={()=>{
                        if(!vehicle.id) vehicle.id = rnd(25);
                        return vehicle.id;
                    }} label='Aracın Fotoğrafı (Önden)' />

                    <ApplyDocumentInput side={true} onFileChange={(file) => {
                        vehicle.side = file;
                        this.forceUpdate();
                    }} file={vehicle.side} getVehicleId={()=>{
                        if(!vehicle.id) vehicle.id = rnd(25);
                        return vehicle.id;
                    }} label='Aracın Fotoğrafı (Yandan)' /> */}

                    <ApplyDocumentInput ruhsat={true} onFileChange={(file) => {
                        vehicle.ruhsat = file;
                        this.forceUpdate();
                    }} file={vehicle.ruhsat} getVehicleId={()=>{
                        if(!vehicle.id) vehicle.id = rnd(25);
                        return vehicle.id;
                    }} label='Ruhsat' />


                    {indx > 0 && <button onClick={() => {
                        this.state.formData.vehicles.splice(indx,1);
                        this.forceUpdate();

                        if(vehicle.id)
                            API.fetch('deletevehicle', {type: vehicle.id, id:window.applicationId}).then((e) => {

                            });
                    }} type='button' className='removeVehicleSvg'><svg xmlns="http://www.w3.org/2000/svg" width="11px" height="13px" viewBox="0 0 11 13" version="1.1">
    <g id="Franchise---Final" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Group-5" transform="translate(-19.000000, -81.000000)" fill="#A4A8B3">
            <g id="Button" transform="translate(0.000000, 72.000000)">
                <g id="Icons-/-16px-/-trash" transform="translate(16.000000, 8.000000)">
                    <g id="icons8-delete" transform="translate(3.000000, 1.000000)">
                        <path d="M4.496094,0 C3.675781,0 3,0.675781 3,1.496094 L3,2 L0,2 L0,3 L1,3 L1,11.5 C1,12.324219 1.675781,13 2.5,13 L8.5,13 C9.324219,13 10,12.324219 10,11.5 L10,3 L11,3 L11,2 L8,2 L8,1.496094 C8,0.675781 7.324219,0 6.503906,0 L4.496094,0 Z M4.496094,1 L6.503906,1 C6.785156,1 7,1.214844 7,1.496094 L7,3 L9,3 L9,11.5 C9,11.78125 8.78125,12 8.5,12 L2.5,12 C2.21875,12 2,11.78125 2,11.5 L2,3 L4,3 L4,1.496094 C4,1.214844 4.214844,1 4.496094,1 Z M3,4 L3,11 L4,11 L4,4 L3,4 Z M5,4 L5,11 L6,11 L6,4 L5,4 Z M7,4 L7,11 L8,11 L8,4 L7,4 Z" id="Shape" fillRule="nonzero"></path>
                    </g>
                </g>
            </g>
        </g>
    </g>
</svg>
</button>}

                </div>)}

                {this.state.formData.vehicles.length < 3 && <div onClick={() => {
                    this.state.formData.vehicles.push({});
                    this.forceUpdate();
                }} className='addVehicleDiv'>
                        <p>Araç Ekle</p>
                    </div>}
                
 
                {/* <p style={{marginTop:20, marginBottom:20,fontSize:16, color:"#575858"}}>By providing us with your phone number and clicking "Submit", you agree that we may call or text you regarding your application. Message & data rates may apply.</p>
                 */}
                </ApplyStep>}


                {this.state.step == 3 && <ApplyStep disabled={!this.state.formData.iban || !this.state.formData.vkn} onPrev={() => this.onPrev()} onNext={async () => {
                    this.setState({step: -1});
                    await API.fetch("applicationupdate", {id: window.applicationId,vkn: this.state.formData.vkn, iban: this.state.formData.iban}).then((e) => {
                        this.setState({step:4});
                    })
                    
                }}>
                    
                    <ApplyInput val={(this.state.formData.iban)?this.state.formData.iban:""} onChangeText={(t) => {
                        this.state.formData.iban = t;
                        this.forceUpdate();
                    }} full label="IBAN" />  
                    <ApplyInput val={(this.state.formData.vkn)?this.state.formData.vkn:""} onChangeText={(t) => {
                        this.state.formData.vkn = t;
                        this.forceUpdate();
                    }} full label="VKN" />    
                    {/* <p style={{marginTop:20, marginBottom:20,fontSize:16, color:"#575858"}}>By providing us with your phone number and clicking "Submit", you agree that we may call or text you regarding your application. Message & data rates may apply.</p>
                 */}
                </ApplyStep>}


                {this.state.step == 4 && <ApplyStep last onPrev={() => this.onPrev()} disabled={!this.state.formData.confirm} onNext={async () => {
                    this.setState({step: -1});
                    await API.fetch("submitapplication", {id: window.applicationId}).then((e) => {
                        this.setState({step:5});
                    })
                    
                }}>
                    
                    
                    <p style={{marginTop:20, marginBottom:20,fontSize:30,color:"#242D3E", fontWeight:700}}>Taşımacım'ın benimle başvurumun ilerlemesi için iletişime geçmesini kabul ediyorum</p>
                    
                    <div style={{width:"100%"}} dangerouslySetInnerHTML={iframe()} />
                    
                    <div style={{display:"flex",flexDirection:"row", marginTop:20, marginBottom:10}}>
                    <input id='checkbox' type={"checkbox"} value={this.state.formData.confirm} onChange={(e) => {
                        this.state.formData.confirm = e.target.checked;
                        this.forceUpdate();

                       
                    }} title={""} className='agreeCheckbox' />
                    <p className='agreeLabel'> Teslimat Şirketi sözleşmesini okudum ve kabul ediyorum</p>
                    </div>
                    {/* <select className='agreeSelect' value={this.state.formData.confirm} onChange={(e) => {
                            this.state.formData.confirm = e.target.value;
                            this.forceUpdate();
                        }} required>
                            <option value={0}>Hayır</option>
                            <option value={1}>Evet</option>
                            
                    </select>   */}
                </ApplyStep>}

                {this.state.step == 5 && <div>
                    
                    <p style={{marginTop:20, marginBottom:20,fontSize:35,color:"#242D3E", fontWeight:700, textAlign:"center"}}>⏳ Başvurunuz Onay Sürecinde.</p>
                    <p style={{marginTop:20, marginBottom:20,fontSize:20,color:"#242D3E", fontWeight:700,textAlign:"center"}}>Tebrikler! Sizi aramızda görmeye can atıyoruz.</p>
                    </div>}



                    {this.state.step == -2 && <div>
                    
                        <p style={{marginTop:20, marginBottom:20,fontSize:35,color:"#242D3E", fontWeight:700, textAlign:"center"}}>Zaten başvuru yaptınız</p>
                        <p style={{marginTop:20, marginBottom:20,fontSize:20,color:"#242D3E", fontWeight:700,textAlign:"center"}}></p>
                    </div>}
            </div>
        </div>
    }

    onPrev() {
        this.setState({step: this.state.step-1});
    }

    onNext() {
        this.setState({step: this.state.step+1});
    }
}



const rnd = (len, chars='ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789') => [...Array(len)].map(() => chars.charAt(Math.floor(Math.random() * chars.length))).join('')

